import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import DatePick from 'vue-date-pick'
import VueNumericInput from 'vue-numeric-input'

export default {
  name: 'HolidaysForm',
  data,
  methods,
  mounted,
  components: {
    DatePick,
    VueNumericInput
  }
}
